document.addEventListener("DOMContentLoaded", function () {
  // ============== START : PDP Review Slider JS ========================
  const nextBtn = document.querySelector(".mhode-next");
  const prevBtn = document.querySelector(".mhode-prev");
  const slideCount = document.querySelectorAll(".mhode-reviews-swiper .swiper-slide").length;
  function toggleNavigation() {
    const showNav = slideCount > (window.innerWidth >= 1024 ? 2 : 1);
    [nextBtn, prevBtn].forEach(btn => {if (btn) btn.style.display = showNav ? "" : "none";});
  }
  window.addEventListener("load", toggleNavigation);
  window.addEventListener("resize", toggleNavigation);

  new Swiper(".mhode-reviews-swiper", {
    loop: false,
    slidesPerView: 1.2,
    spaceBetween: 12,
    navigation: {
      nextEl: ".mhode-next",
      prevEl: ".mhode-prev",
    },
    breakpoints: {
      768: { slidesPerView: 2 },
      900: { slidesPerView: 1.2 },
      1024: { slidesPerView: 2 }
    }
  });

  // ============== END : PDP Review Slider JS ========================

  //================= START : Home page how to work  js  ========================
  new Swiper('.mhode-hiw-slider', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    autoHeight: true,

    pagination: {
      el: '.mhode-hiw-pagination',
      type: 'fraction',
    },

    navigation: {
      nextEl: '.mhode-hiw-next',
      prevEl: '.mhode-hiw-prev',
    },
  });

  //================= END : Home page how to work  js  ========================


  // =================== START: PDP Use Cases JS =======================
  const wrapper = document.querySelector(".mhode-uc .swiper-wrapper");
  if (wrapper) {
    const originalHTML = wrapper.innerHTML;
    let swiper = null;
    let isMobile = false;
    const initMobile = () => {
      const cards = [...wrapper.querySelectorAll(".mhode-uc__card")];
      wrapper.innerHTML = "";
      for (let i = 0; i < cards.length; i += 3) {
        const slide = document.createElement("div");
        slide.className = "swiper-slide";
        const stack = document.createElement("div");
        stack.className = "mobile-stack";
        cards.slice(i, i + 3).forEach(card => stack.appendChild(card));
        slide.appendChild(stack);
        wrapper.appendChild(slide);
      }
      swiper = new Swiper(".mhode-uc__slider", {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: { el: ".swiper-pagination",type: "fraction",},
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev",
        },
      });
      isMobile = true;
    };
    const destroyMobile = () => {
      swiper?.destroy(true, true);
      swiper = null;
      wrapper.innerHTML = originalHTML;
      isMobile = false;
    };
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      if (mobile && !isMobile) {initMobile();}
      else if (!mobile && isMobile) {destroyMobile();}
    };
    handleResize();
    window.addEventListener("resize", handleResize);
  }

  // =================== END: PDP Use Cases JS =======================


  // ==================== START: Product top part wrap js ==================
    const productMediaWrapper = document.querySelector(".mhode-pdp2__visual");
    const elements = document.querySelectorAll( ".mhode-pdp2__info-block .mhode-pdp2__prod-hd, .mhode-pdp2__info-block .mhode-pdp2__rating-row");
    if (!productMediaWrapper || !elements.length) return;
    const mediaQuery = window.matchMedia("(max-width: 899px)");
    let mobileWrapper;
    const placeholders = [...elements].map(element => {
      const placeholder = document.createElement("div");
      placeholder.hidden = true;
      element.before(placeholder);
      return { element, placeholder };
    });
    const handleLayoutChange = ({ matches }) => {
      if (matches) {
        mobileWrapper ??= document.createElement("div");
        mobileWrapper.className = "mobile-product-content";
        if (!mobileWrapper.parentNode) {
          productMediaWrapper.before(mobileWrapper);
        }
        const fragment = document.createDocumentFragment();
        placeholders.forEach(({ element }) => fragment.appendChild(element));
        mobileWrapper.appendChild(fragment);
        return;
      }
      placeholders.forEach(({ element, placeholder }) =>
        placeholder.after(element)
      );
      mobileWrapper?.remove();
    };
    handleLayoutChange(mediaQuery);
    mediaQuery.addEventListener("change", handleLayoutChange);

  function moveTierFeats() {
    document.querySelectorAll('.mhode-pdp2__tier').forEach((tier) => {
      const inner = tier.querySelector('.mhode-pdp2__tier-inner');
      const info = tier.querySelector('.mhode-pdp2__tier-info');
      const feats = tier.querySelector('.mhode-pdp2__tier-feats');
      if (!inner || !info || !feats) return;
      if (window.innerWidth <= 767) {
        if (feats.previousElementSibling !== inner) {
          inner.insertAdjacentElement('afterend', feats);
        }
      } else {
        const hr = info.querySelector('.mhode-pdp2__tier-hr');
        if (hr && feats.parentElement !== info) {
          hr.insertAdjacentElement('afterend', feats);
        }
      }
    });
  }
  moveTierFeats();
  window.addEventListener('resize', moveTierFeats);

  // ==================== END: Product top part wrap js ==================

  
  // ==================== START: Product Left Review append js ==================

    const social = document.querySelector(".mhode-pdp2__social");
    const buySection = document.querySelector(".mhode-pdp2__buy");
    if (!social || !buySection) return;
    const originalParent = social.parentNode;
    const originalNextSibling = social.nextSibling;
    function moveSocialSection() {
      const isMobile = window.innerWidth <= 899;
      if (isMobile) {
        if (social.parentNode !== buySection) {
          buySection.appendChild(social);
        }
      } else {
        if (social.parentNode !== originalParent) {
          originalParent.insertBefore(social, originalNextSibling);
        }
      }
    }
    moveSocialSection();
    window.addEventListener("resize", moveSocialSection);

  // ==================== END: Product Left Review append js ==================

  // =================== START : PDP Top part Accordion JS ====================
  
    const accordions = document.querySelectorAll('.mhode-pdp2__accordion');
    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('summary');
      const body = accordion.querySelector('.mhode-pdp2__acc-body');
      body.style.overflow = 'hidden';
      body.style.maxHeight = '0px';
      body.style.transition = 'max-height 0.4s ease';
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = accordion.open;
        accordions.forEach((item) => {
          if (item !== accordion && item.open) {
            const otherBody = item.querySelector('.mhode-pdp2__acc-body');
            otherBody.style.maxHeight = '0px';
            setTimeout(() => {
              item.open = false;
            }, 0);
          }
        });
        if (isOpen) {
          body.style.maxHeight = '0px';
          setTimeout(() => {
            accordion.open = false;
          }, 0);
        } else {
          accordion.open = true;
          requestAnimationFrame(() => {
            body.style.maxHeight = body.scrollHeight + 'px';
          });
        }
      });
    });

  // =================== END : PDP Top part Accordion JS ====================
  // =================== START : Key Benefits Accordion JS ====================
  (function () {
    document.querySelectorAll('.mhode-why').forEach(function (root) {
      const items = root.querySelectorAll('.mhode-why__benefit');
      items.forEach(function (det) {
        const content = det.querySelector('.mhode-why__benefit-content');
        if (det.open) {
          det.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
        det.querySelector('summary').addEventListener('click', function (e) {
          e.preventDefault();
          const isOpen = det.open;
          items.forEach(function (other) {
            if (other !== det && other.open) {
              const otherContent = other.querySelector('.mhode-why__benefit-content');
              otherContent.style.maxHeight = '0px';
              setTimeout(() => {
                other.open = false;
                other.classList.remove('is-open');
              }, 350);
            }
          });
          if (!isOpen) {
            det.open = true;
            det.classList.add('is-open');
            requestAnimationFrame(() => {
              content.style.maxHeight = content.scrollHeight + 'px';
            });
          } else {
            content.style.maxHeight = '0px';
            setTimeout(() => {
              det.open = false;
              det.classList.remove('is-open');
            }, 350);
          }
        });
      });
    });
  })();
  // =================== END : Key Benefits Accordion JS ====================
});